import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function AuCard(props) {
  const categoryData = props.data;
  return (
    <>
    <Link className="text-decoration-none d-none" to={`/liveAuctionNft/${categoryData?._id}`}>
      <div className="LiveAucBoxMain">
        <div className="imgBox">
          <div className="imginn">
            <img className="img-fluid w-100" src={categoryData?.nft_id?.image_id?.image?.link} alt="" />
          </div>
          <button className="priceTag">Price - {categoryData?.current_price} <img src="images/svg/maticIcon.svg" width={25} height={25} alt="Matic" /> </button>
        </div>
        <div className="contBox">
        <div className="buttonBox">
                <button className="openAmout">
              
                  Opening Amount - {categoryData?.nft_id?.price} <img src="images/svg/maticIcon.svg" width={18} height={18} alt="Matic" />
                </button>
                <button className="totalbid">Total bids - {categoryData?.no_of_bids}</button>
           
              </div>
          <div className="arthead mb-2">
            <h2 className="productName">{categoryData?.nft_id?.name}</h2>
            {/* <p className="viewBox">
          <span>Views</span> --
        </p> */}
          </div>
          {/* <p>
        Origin Story is partnered with top collections such as Pudgy
        Penguins.
      </p> */}
        </div>
        {/* <div className="position-relative">
          <div className="buttonBox">
      <button className="openAmout">Opening Amount - {categoryData?.nft_id?.price} MATIC</button>
            <button className="totalbid">Total bids till now - 0</button>
          </div>
        </div> */}
      </div>
    </Link>

     <Link className="text-decoration-none" to={ categoryData?.sellType==="auction"  ? `/liveAuctionNft/${props?.data?._id}` :`/nftsale/${props?.data?._id}`  }>
      <div className="artItemBoxNew">
      <div className="imgBox">
      <div className="imginn">
        <img
          className="img-fluid"
          src={categoryData?.nft_id?.image_id?.image?.link}
          alt=""
        />
        </div>
          <button className="priceTag">Price - {categoryData?.current_price} <img src="images/svg/maticIcon.svg" width={25} height={25} alt="Matic" /> </button>
      </div>
      <div className="contBox">
      <div className="buttonBox">
                <button className="openAmout">
              
                  Opening Amount - {categoryData?.nft_id?.price} <img src="images/svg/maticIcon.svg" width={18} height={18} alt="Matic" />
                </button>
                <button className="totalbid">Total bids - {categoryData?.no_of_bids}</button>
           
              </div>
        <div className="arthead">
          <h2 className="productName" title={categoryData?.nft_id?.name}>{categoryData?.nft_id?.name} </h2>
          <h2 className="productPrice d-flex align-items-center gap-2">{categoryData?.nft_id?.price} <img src="/images/svg/maticIcon.svg" width={18} height={18} alt="Matic" /></h2>
        </div>
        <p>{categoryData.description}</p>
      </div>
    </div>
  </Link>
  </>
  );
}
